import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../store/store";

export type MasterCoverageItem = {
  id: number;
  label: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
};

type MasterCoverageState = {
  masterCoverage: MasterCoverageItem[];
};

const initialState: MasterCoverageState = {
  masterCoverage: [],
};

const masterCoverageSlice = createSlice({
  name: "masterCoverage",

  initialState,

  reducers: {
    setMasterCoverage: (state, action: PayloadAction<MasterCoverageItem[]>) => {
      state.masterCoverage = action.payload;
    },
  },
});

export const { setMasterCoverage } = masterCoverageSlice.actions;
export const selectMasterCoverage = (state: RootState) => state.masterCoverage;

export default masterCoverageSlice.reducer;
